import Cookies from "js-cookie";

import { logError } from "@shared/functions/log";

import type Survey from "@packages/types/survey";

export default function getSurveyCookie(surveyType: string) {
  const cookieName = surveyType + "-cookie";

  let cookie = Cookies.get(cookieName);

  if (cookie) {
    try {
      return JSON.parse(cookie) as Survey.Cookie;
    } catch (e) {
      logError({
        message: "getSurveyCookie was unable to parse cookie",
        event: {
          name: "getSurveyCookie",
          meta: {
            cookie,
          },
        },
      });
    }
  }

  return;
}
